import merge from 'lodash/merge';

export default function accordion(state = {}, action) {
  if (action.type === 'OPEN_ACCORDION') {
    const { name, index, config = {} } = action;
    const nextState = merge({}, state);
    if (!nextState[name]) {
      nextState[name] = {
        name,
        entities: {},
        results: []
      };
    }
    if (nextState[name]) {
      nextState[name].entities[index] = {
        index,
        state: config.state
      };
      nextState[name].results.push(index);
    }
    return nextState;
  }
  if (action.type === 'CLOSE_ACCORDION') {
    const { name, index } = action;
    const nextState = merge({}, state);
    if (nextState[name] && nextState[name].entities[index]) {
      delete nextState[name].entities[index];
      const i = nextState[name].results.indexOf(index);
      if (i > -1) {
        nextState[name].results.splice(i, 1);
      }

      if (nextState[name].results.length < 1) {
        delete nextState[name];
      }
      return nextState;
    }
  } else if (action.type === 'TOGGLE_ACCORDION') {
    const { name, index, item = '' } = action;
    let nextState = merge({}, state);
    nextState[name] = nextState[name] ? nextState[name] : {};
    let { results = [] } = nextState[name];
    let wasAvailable = results.indexOf(index) == -1;
    nextState[name].entities = {};
    nextState[name].results = [];
    if (wasAvailable) {
      nextState[name].entities[index] = { index };
      nextState[name].active = item;
      nextState[name].results.push(index);
    }
    return nextState;
  }
  return state;
}
